import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Section } from "@/components/Section";
import guide from "@/data/homeGuide.json";

export const KeyNumbers = () => (
  <Section id="key-numbers" eyebrow="At a glance" title="Key Numbers Behind the SpaceX Share Pledge">
    <div data-testid="home-key-numbers" className="grid gap-4 grid-cols-2 md:grid-cols-3">
      {guide.numbers.map((n) => (
        <div key={n.value} className="rounded-xl border border-slate-800 bg-[#121722] p-5">
          <p className="font-display text-2xl sm:text-3xl font-extrabold text-white">{n.value}</p>
          <p className="mt-2 text-xs sm:text-sm leading-relaxed text-slate-400">{n.label}</p>
        </div>
      ))}
    </div>
  </Section>
);

export const ParentChecklist = () => (
  <Section id="parent-checklist" eyebrow="For parents" title="A Parent's Checklist While Details Develop">
    <ol data-testid="home-checklist" className="grid gap-4 md:grid-cols-2">
      {guide.checklist.map((c, i) => (
        <li key={c.h} className="flex gap-4 rounded-xl border border-slate-800 bg-[#121722] p-5">
          <span className="font-mono text-sm font-bold text-sky-400">{String(i + 1).padStart(2, "0")}</span>
          <div className="space-y-1.5">
            <h3 className="font-display font-semibold text-slate-100">{c.h}</h3>
            <p className="text-sm leading-relaxed text-slate-400">{c.p}</p>
          </div>
        </li>
      ))}
    </ol>
  </Section>
);

export const Glossary = () => (
  <Section id="glossary" eyebrow="Glossary" title="Terms Parents Will See in the News">
    <dl data-testid="home-glossary" className="grid gap-x-8 gap-y-4 md:grid-cols-2">
      {guide.glossary.map((g) => (
        <div key={g.t} className="border-b border-slate-800 pb-4">
          <dt className="font-semibold text-slate-100">{g.t}</dt>
          <dd className="mt-1 text-sm leading-relaxed text-slate-400">{g.d}</dd>
        </div>
      ))}
    </dl>
  </Section>
);

export const GuideHub = () => (
  <Section id="guide-hub" eyebrow="Guides & tools" title="Explore Our Guides">
    <div data-testid="home-guide-hub" className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {guide.guides.map((g) => (
        <Link key={g.to} to={g.to} data-testid={`home-guide-${g.to.slice(1)}`} className="group rounded-xl border border-slate-800 bg-[#121722] p-5 hover:border-[#0052FF] transition-colors">
          <h3 className="flex items-center justify-between font-display font-semibold text-slate-100">{g.h}<ArrowRight className="h-4 w-4 text-sky-400 group-hover:translate-x-0.5 transition-transform" /></h3>
          <p className="mt-1.5 text-sm text-slate-400">{g.p}</p>
        </Link>
      ))}
    </div>
  </Section>
);
